
import CurrencyConverter from "../common/currency-converter.vue";
import priceBreakdownDialog from "../dialogs/price-breakdown-dialog.vue";
export default {
  props: {
    order: { type: Object, dafault: {} }
  },
  components: { priceBreakdownDialog, CurrencyConverter },
  data() {
    return {
      showPriceBreakdown: false
    };
  }
};
